<div class="auto-complete">
  <input type="text" 
    class="input" 
    [ngStyle]="{'height.px': height}" 
    [ngClass]="{'active': active}"
    [formControl]="control" 
    [placeholder]="placeholder"
    (keyup)="filterOptions($event)"
    (focus)="toogleDropdown()"
  />

  <div class="content" *ngIf="active"> 
    <ul class="options">
      <li class="option" *ngFor="let option of options" (click)="selectOption(option)">
        <div>{{ option.label }}</div>
      </li>
    </ul>
  </div>
</div>